/* eslint-disable */
import React from 'react';

import WpLink from '../WpLink';
import { WpIcon } from 'Wpds/components/icon';

const LinkDocs = () => {
  return (
    <div>
      Create an anchor tag using the Link component from react-router-dom for internal app routing
      {/* <a class="WpLink" href="/">Home</a> */}
      <WpLink href="/">Home</WpLink>
      <hr />
      Create an anchor tag link with target="_blank" and rel="noopenener noreferrer"
      {/* <a target="_blank" href="https://predictiveindex.com" rel="noopener noreferrer" class="WpLink">predictiveindex.com</a> */}
      <WpLink href="https://predictiveindex.com">predictiveindex.com</WpLink>
      <hr />
      With WpIcon Left
      <WpLink href="https://predictiveindex.com">
        <WpIcon name="external-link" />
        Learn More
      </WpLink>
      <hr />
      With WpIcon Right
      <WpLink href="https://predictiveindex.com">
        Learn More
        <WpIcon name="external-link" />
      </WpLink>
    </div>
  );
};

export default LinkDocs;
